<div>
  <h1>Actor Forms</h1>
  <!--<div class="form-group text-center">
    <CustomDataByRequestType RequestedType="FDTemplateByActorReportCode" id="ActorReportTemplateCode" [(ngModel)]="ActorReportTemplateCode"
                             name="ActorReportTemplateCode" required
                             (keyChange)="onFDTemplateByCode($event)">
    </CustomDataByRequestType>
  </div>
  <div class="form-group text-center">
    <button type="button" class="btn btn-warning btn-raised" (click)="onSubmitTemplate()" *ngIf='!isRequesting'>Create</button>
    </div>-->

  <div class="row">
    <div class="col-sm-12">
      <data-grid *ngIf="CurrentFdActorReportsDocController"
                 [columns]="columns" [data]="CurrentFdActorReportsDocController"
                 [hdrbtns]="hdrbtns"
                 [gridbtns]="gridbtns"
                 [sort]="sorting"
                 (btnclick)="gridaction($event)">
      </data-grid>

    </div>
  </div>
</div>

